import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from "vue-gtag";
import './assets/css/global.css'
import store from './store'
import Quasar from 'quasar/src/vue-plugin.js';
import axios from 'axios'
import VueAxios from 'vue-axios'
import quasarUserOptions from './quasar-user-options'
import './registerServiceWorker'
var app = createApp(App)

app.use(Quasar, quasarUserOptions)

app.use(router)

//Google Analytics
app.use(VueGtag, {
  config: {id: process.env.VUE_APP_GA_ID},
  router,
  enabled: true
})

app.use(store)

axios.interceptors.request.use(function (config) {
  config.headers.common['Content-Type'] = 'application/json'
  config.headers.common['Accept'] = 'application/json'
  config.withCredentials = true
  config.maxRedirects =  0

  return config
}, function (err) {
  return Promise.reject(err)
})

app.use(VueAxios, axios)

app.provide('axios', app.config.globalProperties.axios)  // provide 'axios'

app.mount('#app')
